// extracted by mini-css-extract-plugin
module.exports = {"form-header-buttons":"header_form-header-buttons__142Nx","form-header-button":"header_form-header-button__1W4f5","form-saving-text":"header_form-saving-text__R8A6C"};